// extracted by mini-css-extract-plugin
export var divider = "_j7-7";
export var itemsToggle = "_j7-8";
export var mergeModal = "_j7-1";
export var optionCard = "_j7-4";
export var radioGroup = "_j7-6";
export var radioOption = "_j7-0";
export var selected = "_j7-5";
export var shipmentOptions = "_j7-2";
export var tableOptions = "_j7-3";